export default __webpack_public_path__ + "static/dennis_johnson-2843be2016fd2c0878313a05bcd65b0d.jpg";